import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { AdminService } from "../../services/admin.service";
import SideModal from "../SideModal/SideModal";
import Select from "react-select";

interface IEditCouncellor {
 dhunguruId: string;
 show:boolean;
 setShow:any;
 reload:any
}

export default function EditCouncellorModel(props: IEditCouncellor) {
  const [councellor, setCouncellor] = useState<any>();
  const [finalState, setFinalState] = useState<any>();
  // const [coordinators, setCoordinators] = useState<any>();

  const onUpdateCouncellorClick = () => {
    if ( !finalState || finalState.length<=0) {
      toast.error("This Fields is mandatory");
      return false;
    }
    AdminService.updateCouncellor(props.dhunguruId,finalState).then(
      (res) => {
        if (res.status === 200) {
          toast.success("Councellor Updated");
          console.log(res?.data,"updatedData");
          props.setShow(false);
          props.reload();
          window.location.reload();
        }
      }
    );
  };

  const fetchCoordinators = () => {
      AdminService.getAllCoordinators().then((res) => {
        if (res.status === 200) {
          const valid_coor = res.data.filter((data: any) => data.adminVisibility.includes("COORDINATOR"));
          const valid_cons = res.data.filter((data: any) => data.adminVisibility.includes("COUNSELLOR"));
  
          // setCoordinators(
          //   valid_coor.map((data: any) => {
          //     return {
          //       value: data._id,
          //       label: `${data.firstName} ${data.lastName}`,
          //     };
          //   })
          // );
          setCouncellor(
            valid_cons.map((data: any) => {
              return {
                value: data._id,
                label: `${data.firstName} ${data.lastName}`,
              };
            })
          );
        }
      });
    };

    const handleChange = (e:any)=>{
      setFinalState(e.target.value);
    }

    useEffect(()=>{
      fetchCoordinators();
    },[]);
  
  return (
    <SideModal
      show={props.show}
      handleClose={() => props.setShow(false)}
      title="Edit"
      body={
        <>
          <Form.Group className="mt-2">
            <Form.Label className="fw-bold text-secondary fs-12">
              Councellor
            </Form.Label>
            <Select
              name="councellorId"
              options={councellor}
              isClearable={true}
              onChange={(e: any) => {
                const event = {
                  target: {
                    name: "councellor",
                    value: e?.label,
                  },
                }
                handleChange(event);
              }}
              value={councellor?.find((data: any) => data.label === finalState)}
            />
          </Form.Group>
          {/* <Form.Group>
            <Form.Label>Councellor</Form.Label>
            <Form.Control
              type="text"
              value={councellor}
              name="councellor"
              onChange={(e) => setCouncellor(e.target.value)}
            />
          </Form.Group> */}
          <Button
            variant="primary"
            size="sm"
            className="mt-3"
            onClick={onUpdateCouncellorClick}
          >
            Update
          </Button>
        </>
      }
    />
  );
}
